import React, { useState, shallowEqual } from 'react';
import SortTableAscending from 'src/assets/images/SortTableAscending.svg';
import SortTableDescending from 'src/assets/images/SortTableDescending.svg';
import { useSelector, useDispatch } from 'react-redux';
import InventoryBodyDesktop from './InventoryBodyDesktop';
import InventoryBodyMobile from './InventoryBodyMobile';
import { setInventoryItems } from 'src/pages/consignmentBilling/redux/actions';
import { checkProxyActive } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import {
    HeaderGridContainer,
    HeaderTextContainer,
    HeaderGridMobileContainer,
    HeaderTextMobileContainer,
    SortIcon,
    // EAIcon,
    InventoryContentWrapper,
} from './InventoryBody.styled';
import { CFN } from './inventoryData.js';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const InventoryBody = (props) => {
    const dispatch = useDispatch();
    const [, setCheckToggle] = useState(false);
    const [qtyValidation, setQtyValidation] = useState(false);
    const [qtyErrorMsg, setQtyErrorMsg] = useState('');
    const [, setInventoryList] = useState([]);
    const [, setCheckedItemsDetails] = useState([]);
    const [checkedItemsDataList, setCheckedItemsDataList] = useState([]);
    const checkedListValue = useSelector(
        (state) => state.inventoryReducer.checkedItems
    );
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const { t } = useTranslation();
    const { bannerHeight } = useSelector((state) => state.loginReducer);

    useEffectWithErrorLogging(() => {
        props.setChecked(props.inventoryDetails);
        props.inventoryDetails &&
            props.inventoryDetails.map((product) => {
                const matchedItem = checkedListValue.find(
                    (item) => item.uniqueKey == product.uniqueKey
                );
                if (matchedItem) {
                    product.isChecked = matchedItem.isChecked;
                    // Sync the used quantity from Redux store
                    product.used = matchedItem.used;
                } else {
                    product.isChecked = false;
                }
            });
        setInventoryList(props.inventoryDetails);
        // dispatch(getInventoryCheckedItems(props.inventoryDetails));
    }, [props.inventoryDetails, checkedListValue]);

    useEffectWithErrorLogging(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });

    const handleChange = (e, clrAll) => {
        let itemIndex = '';
        let checkedItems = props.inventoryDetails;
        let checkedItemsList = [...checkedListValue];
        let checkedItemsData = [];
        props.inventoryDetails &&
            props.inventoryDetails.map((user, index) => {
                itemIndex = checkedItemsList.findIndex(
                    (product) => product.uniqueKey == user.uniqueKey
                );
                //setItemData(itemIndex,1);
                setCheckToggle(true);
                if (user.uniqueKey == e.target.value || itemIndex >= 0) {
                    checkedItems[index].isChecked = e.target.checked;
                    const existingItemInStore = itemIndex >= 0 ? checkedItemsList[itemIndex] : null;
                    if (existingItemInStore && existingItemInStore.used) {
                        checkedItems[index].used = existingItemInStore.used;
                    } else if (user.used && user.used > 0) {
                        checkedItems[index].used = user.used;
                    } else if (!checkedItems[index].used || checkedItems[index].used === 0) {
                        checkedItems[index].used = 1;
                    }
                    checkedItems[index].checkedIndex = index;
                    checkedItems[index].inventoryIndex = index;
                    checkedItems[index].flag = false;
                    if (
                        user.uniqueKey == e.target.value &&
                        itemIndex >= 0 &&
                        !e.target.checked
                    ) {
                        delete checkedItemsList.splice(itemIndex, 1);
                    } else if (
                        user.uniqueKey == e.target.value &&
                        e.target.checked
                    ) {
                        checkedItemsList.push({ ...checkedItems[index] });
                        checkedItemsData = [
                            ...checkedItemsDataList,
                            { ...checkedItems[index] },
                        ];
                        setCheckedItemsDataList(checkedItemsData);
                    }
                } else {
                    checkedItems[index].isChecked = false;
                    //checkedItems[index].isChecked = false;
                }
            });
        dispatch(setInventoryItems(checkedItemsList));
        props.setChecked([...checkedItems]);
        setCheckedItemsDetails(checkedItemsData);
        selectedItemsCount(checkedItemsData);
        handleSlectedItems(checkedItemsData);
    };

    const selectedItemsCount = (checkedItems) => {
        const count = checkedItems.reduce((counter, obj) => {
            if (obj?.flag === false && obj.isChecked === true) counter += 1;
            return counter;
        }, 0);
        props.setItemCheckedCount(count);
    };

    const handleSlectedItems = (checkedItems) => {
        let arr = [];
        let itemsSelected = checkedItems.filter((obj) => {
            return obj.isChecked === true;
        });
        itemsSelected.map((value) => {
            arr[value.checkedIndex] = value;
        });
        props.setFilterCheckedItems(arr);
        props.setItemsVal(arr);
    };

    const setItemData = (index, value, uniqueKey) => {
        
        const parsedValue = value && value !== '' ? parseInt(value) : (value === '' ? '' : 0);
        
        if (props.inventoryDetails && props.inventoryDetails[index]) {
            props.inventoryDetails[index].used = parsedValue;
        }
        
        let itemVal = [...checkedListValue];
        if (
            itemVal &&
            // itemVal.hasOwnProperty('used') &&
            // value !== undefined &&
            itemVal.length > 0
        ) {
            itemVal.map((item) => {
                if (item.uniqueKey === uniqueKey && item.checkedIndex === index) {
                    item.used = parsedValue;
                }
            });
            props.setItemsVal(itemVal);
            dispatch(setInventoryItems(itemVal));
        }
    };

    // banner height manage

    const [showBanner, setShowBanner] = useState(false);

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );
    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );
    useEffectWithErrorLogging(() => {
        let userInfoMessages = [];
        if (bannerInfo) {
            userInfoMessages = bannerInfo.filter(
                (item) => item.messageType === 'userInfoMessage'
            );
        }
        if (userInfoMessages.length > 0) {
            setShowBanner(true);
        }
    }, []);

    const showSingleBanner =
        checkProxyActive() || isImpersonationActive || showBanner;
    const showDoubleBanner =
        (checkProxyActive() && showBanner) ||
        (isImpersonationActive && showBanner);

    return (
        <>
            <HeaderGridContainer
                container
                justifyContent={'space-between'}
                direction="row"
            >
                <HeaderTextContainer isCondensedView={isCondensedView}
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={1}
                    style={{
                        marginRight: '-55px',
                    }}
                >
                    {t('consignmentBilling.inventory.used')}
                </HeaderTextContainer>
                <HeaderTextContainer 
                id={`consignmentBilling-inventory-headerTextContainer-itemDetails-${props.sortParams || 'default'}`}
                isCondensedView={isCondensedView}
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    lg={4}
                    xl={4}
                    mobile={12}
                    className={'ItemDetailsHeader'}
                    style={{
                        cursor: 'pointer',
                    }}
                    onClick={() =>
                        props.sortChangeHandler(CFN, props.sortOrder)
                    }
                >
                    {t('consignmentBilling.inventory.itemDetails')}
                    {props.sortParams === CFN ? (
                        <SortIcon>
                            {props.sortOrder === 'ASC' ? (
                                <img
                                    src={SortTableAscending}
                                    alt="SortTableAscending"
                                    value={props.sortOrder}
                                    width="auto"
                                    height="auto"
                                    // onClick={() => {
                                    //     props.setSortOrderName('DESC');
                                    // }}
                                ></img>
                            ) : (
                                <img
                                    src={SortTableDescending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    value={props.sortOrder}
                                    // onClick={() => {
                                    //     props.setSortOrderName('ASC');
                                    // }}
                                ></img>
                            )}
                        </SortIcon>
                    ) : null}
                </HeaderTextContainer>
                <HeaderTextContainer isCondensedView={isCondensedView}
                    item
                    xs={12}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={2}
                    mobile={1}
                    className={'uom-ipad-header'}
                >
                    {t('consignmentBilling.inventory.uom')}
                </HeaderTextContainer>
                <HeaderTextContainer isCondensedView={isCondensedView}
                    item
                    xs={2}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={2}
                >
                    {t('consignmentBilling.inventory.usedQty')}
                </HeaderTextContainer>
                <HeaderTextContainer
                 id={`consignmentBilling-inventory-headerTextContainer-onHand-${props.sortParams || 'default'}`}
                 isCondensedView={isCondensedView}
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={1}
                    className={'nowrap-text-responsive'}
                    style={{
                        paddingRight: '20px',
                        cursor: 'pointer',
                    }}
                    onClick={() =>
                        props.sortChangeHandler('onhand', props.sortOrder)
                    }
                >
                    {t('consignmentBilling.inventory.onHand')}
                    {props.sortParams === 'onhand' ? (
                        <SortIcon>
                            {props.sortOrder === 'ASC' ? (
                                <img
                                    src={SortTableAscending}
                                    alt="SortTableAscending"
                                    value={props.sortOrder}
                                    width="auto"
                                    height="auto"
                                    // onClick={() => {
                                    //     props.setSortOrderName('DESC');
                                    // }}
                                ></img>
                            ) : (
                                <img
                                    src={SortTableDescending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    value={props.sortOrder}
                                    // onClick={() => {
                                    //     props.setSortOrderName('ASC');
                                    // }}
                                ></img>
                            )}
                        </SortIcon>
                    ) : null}
                </HeaderTextContainer>
                <HeaderTextContainer
                    isCondensedView={isCondensedView}
                    item
                    xs={12}
                    sm={1}
                    md={1}
                    lg={2}
                    xl={2}
                    mobile={12}
                    style={{
                        paddingLeft: '40px',
                        whiteSpace: 'nowrap',
                    }}
                >
                    <span
                        id={`consignmentBilling-inventory-headerTextContainer-batch-${props.sortParams || 'default'}`}
                        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                        onClick={() => props.sortChangeHandler('batch', props.sortOrder)}
                    >
                        {t('consignmentBilling.inventory.lotorserial')}
                        {props.sortParams === 'batch' ? (
                            <SortIcon>
                                {props.sortOrder === 'ASC' ? (
                                    <img
                                        src={SortTableAscending}
                                        alt="SortTableAscending"
                                        value={props.sortOrder}
                                        width="auto"
                                        height="auto"
                                    />
                                ) : (
                                    <img
                                        src={SortTableDescending}
                                        alt="SortTableDescending"
                                        width="auto"
                                        height="auto"
                                        value={props.sortOrder}
                                    />
                                )}
                            </SortIcon>
                        ) : null}
                    </span>
                </HeaderTextContainer>
                <HeaderTextContainer
                    isCondensedView={isCondensedView}
                    item
                    xs={12}
                    sm={2}
                    md={2}
                    lg={1}
                    xl={1}
                    mobile={12}
                    align={'right'}
                    style={{
                        alignText: 'right',
                    }}
                    className={'text-align-right'}
                >
                    <span
                        id={`consignmentBilling-inventory-headerTextContainer-useBy-${props.sortParams || 'default'}`}
                        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                        onClick={() => props.sortChangeHandler('usebydate', props.sortOrder)}
                    >
                        {t('consignmentBilling.inventory.useBy')}
                        {props.sortParams === 'usebydate' ? (
                            <SortIcon>
                                {props.sortOrder === 'ASC' ? (
                                    <img
                                        src={SortTableAscending}
                                        alt="SortTableAscending"
                                        value={props.sortOrder}
                                        width="auto"
                                        height="auto"
                                    />
                                ) : (
                                    <img
                                        src={SortTableDescending}
                                        alt="SortTableDescending"
                                        width="auto"
                                        height="auto"
                                        value={props.sortOrder}
                                    />
                                )}
                            </SortIcon>
                        ) : null}
                    </span>
                </HeaderTextContainer>
            </HeaderGridContainer>

            <HeaderGridMobileContainer
                container
                justifyContent={'space-between'}
                direction="row"
                mbHeaderPadding={' 10px 0px 10px 10px'}
            >
                <HeaderTextMobileContainer
                    item
                    xs={1}
                    sm={1}
                    md={2}
                    lg={2}
                    xl={2}
                    mobile={2}
                >
                    {t('consignmentBilling.inventory.used')}
                </HeaderTextMobileContainer>
                <HeaderTextMobileContainer
                    item
                    xs={7}
                    sm={7}
                    md={7}
                    lg={7}
                    xl={7}
                    mobile={7}
                >
                    {t('consignmentBilling.inventory.itemDetails')}
                </HeaderTextMobileContainer>
                <HeaderTextMobileContainer
                    item
                    xs={3}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    mobile={3}
                >
                    <div style={{ marginLeft: '15px' }}>
                        {t('consignmentBilling.inventory.usedQty')}
                    </div>
                </HeaderTextMobileContainer>
            </HeaderGridMobileContainer>
            <InventoryContentWrapper
                className={'inventory-body-content-wrapper'}
                showSingleBanner={showSingleBanner}
                showDoubleBanner={showDoubleBanner}
                bannerHeight={bannerHeight}
            >
                {props.inventoryDetails &&
                    props.inventoryDetails.map((user, index) => {
                        return (
                            <>
                                <InventoryBodyDesktop
                                    user={user}
                                    handleChange={handleChange}
                                    //handleQtyValidation={handleQtyValidation}
                                    qtyValidation={qtyValidation}
                                    index={index}
                                    //key={index}
                                    setQtyVal={props.setQtyVal}
                                    setQtyErrorMsg={setQtyErrorMsg}
                                    setQtyValidation={setQtyValidation}
                                    qtyErrorMsg={qtyErrorMsg}
                                    qtyVal={props.qtyVal}
                                    setQuantityValue={(value) => {
                                        props.setInputValue(value);
                                    }}
                                    setItemDetails={(index, value, uniqueKey) => {
                                        setItemData(index, value, uniqueKey);
                                    }}
                                    setValidation={(value) => {
                                        //props.setValid(value);
                                    }}
                                    clrAll={props.clrAll}
                                />

                                <InventoryBodyMobile
                                    user={user}
                                    handleChange={handleChange}
                                    //handleQtyValidation={handleQtyValidation}
                                    qtyValidation={qtyValidation}
                                    index={index}
                                    key={index}
                                    setQtyVal={props.setQtyVal}
                                    setQtyErrorMsg={setQtyErrorMsg}
                                    setQtyValidation={setQtyValidation}
                                    qtyErrorMsg={qtyErrorMsg}
                                    setQuantityValue={(value) => {
                                        props.setInputValue(value);
                                    }}
                                    setItemDetails={(index, value, uniqueKey) => {
                                        setItemData(index, value, uniqueKey);
                                    }}
                                    clrAll={props.clrAll}
                                />
                            </>
                        );
                    })}
            </InventoryContentWrapper>
        </>
    );
};

export default InventoryBody;
